import i18next from "i18next";

export const ADDRESS_MAX_LENGTH = 200;
export const COMPANY_NAME_MAX_LENGTH = 200;
export const EMAIL_MAX_LENGTH = 200;
export const POSTCODE_LENGTH = 10;
export const CITY_MAX_LENGTH = 50;

export const getCountries = () => [
  { label: i18next.t("Germany"), value: "DE" },
  { label: i18next.t("Austria"), value: "AT" },
  { label: i18next.t("Switzerland"), value: "CH" },
  { label: i18next.t("Netherlands"), value: "NL" },
  { label: i18next.t("Belgium"), value: "BE" },
  { label: i18next.t("France"), value: "FR" },
  { label: i18next.t("Spain"), value: "ES" },
  { label: i18next.t("Poland"), value: "PL" },
  { label: i18next.t("Romania"), value: "RO" },
  { label: i18next.t("Czech Republic"), value: "CZ" },
  { label: i18next.t("Ireland"), value: "IE" },
  { label: i18next.t("United Kingdom"), value: "GB" },
  { label: i18next.t("United States"), value: "US" }
];

export const COUNTRIES_WITHOUT_TAXES = getCountries()
  .map((country) => country.value)
  .filter((value) => value !== "DE");
